// extracted by mini-css-extract-plugin
export default {"container":"Registration_container__xQAdn","content":"Registration_content__-m6mS"};